import {useQuery} from "react-query";
import {getRestaurant} from "../service/RestaurantService";

export const useRestaurant = (restaurantId) => {
    return useQuery({
        queryKey: ['restaurant', restaurantId],
        queryFn: () => getRestaurant(restaurantId).then((response) => response.data),
        enabled: !!restaurantId
    })
}